import { LogoConfig } from './ToolbarLogo';

export const DEFAULT_LOGO_CONF: LogoConfig = {
  fileName: 'logo-text.svg',
  width: 200,
  label: 'Tertius',
};

const INSPECTIONS_LOGO_CONF: LogoConfig = {
  fileName: 'logo-inspections.svg',
  width: 325,
  label: 'Tertius DOB Constructions Inspections',
};

const ELEVATORS_LOGO_CONF: LogoConfig = {
  fileName: 'logo-elevators.svg',
  width: 425,
  label: 'Tertius Elevators',
};

export const getLogoConfig = (currentApp: string): LogoConfig => {
  if (currentApp === 'dcra-inspections') {
    return INSPECTIONS_LOGO_CONF;
  }
  if (currentApp === 'elevators') {
    return ELEVATORS_LOGO_CONF;
  }
  return DEFAULT_LOGO_CONF;
};
